module.exports = __webpack_public_path__ + "static/media/Videos.fe490f96.png";